import { nameOf, usePeople } from "@/lib/people";

/** Show the record's creator, independently of its current reviewer or editor. */
export function AuthorLabel({ authorId }: { authorId: string | null }) {
  const people = usePeople();
  const name = nameOf(people.data, authorId);
  return <span className="break-words text-meta text-hint">
    Автор: {name ?? (people.isPending ? "загружается…" : "имя недоступно")}
  </span>;
}
